import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/packageOrderDetail';
import React, { Component } from 'react';
import { Row, Col, Select, Checkbox } from 'antd';

import {
  thumbnailImageUrl,
  currencyText,
  getStatusColor,
  getActionParams,
} from 'theme/utils';
import Image from 'theme/Image';
import Button from 'theme/Button';
import PrintableArea from 'components/partials/PrintableArea';
import PrintableView from '../printableView';
import $S from 'theme/settings';

const { Option } = Select;

class MobileView extends Component {
  state = {
    selectedActionId: 'empty',
    selectedIds: [],
  };

  handleActionChange = (id) => {
    this.setState({ selectedActionId: id });
  };

  isActionSelected = () => {
    const { selectedActionId } = this.state;
    return selectedActionId && selectedActionId !== 'empty';
  };

  handleCheckBoxChange = (packageItem) => {
    const { selectedIds } = this.state;
    const { id } = packageItem;

    if (!selectedIds.includes(id)) selectedIds.push(id);
    else {
      const index = selectedIds.findIndex((selectedId) => selectedId === id);
      if (index < 0) return null;
      selectedIds.splice(index, 1);
    }
    this.setState({ selectedIds });
  };

  isPackageItemChecked = (packageItem) => {
    const { selectedIds } = this.state;
    const { id } = packageItem;
    return selectedIds.includes(id);
  };

  render() {
    const {
      onOpenImageModal,
      packageOrder: {
        state,
        orderNumber,
        orderNotes,
        shippingAddress: {
          customerName,
          customerSurname,
          phone,
          title,
          line,
          city,
        },
        packageItemSet,
      },
      packageOrder,
      pendingAnyAction,
      actionButtons = [],
      onActionClick,
    } = this.props;
    const { selectedActionId, selectedIds } = this.state;

    const selectBoxOptions = actionButtons.filter(
      ({ selectionRequired }) => selectionRequired
    );

    const actionButton = actionButtons.filter(
      ({ selectionRequired }) => !selectionRequired
    )[0];

    const statusStyle = {
      backgroundColor: getStatusColor(state && state.id, 'package'),
    };

    const isOptionDisabled = (command) =>
      command === 'DETECTED_OUT_OF_STOCK_ITEM'
        ? state.enum_value === '200'
        : false;

    const isApplyButtonClickable =
      selectedIds.length && this.isActionSelected() && !pendingAnyAction;

    return (
      <div className='package-order-detail-mobile oms'>
        <div className='container-fluid headerMargin pb56'>
          <div className='mb30'>
            <p className='large'>{$ST.ORDER_INFO}</p>
          </div>
          <Row className='mb18'>
            <Col span={12}>
              <p className='bold'>{$ST.ORDER_NUMBER_SHORT}</p>
              <p className='special-color bold'>{orderNumber && orderNumber}</p>
            </Col>
            <Col span={12}>
              {state && state.name && (
                <p className='status' style={statusStyle}>
                  {state.name}
                </p>
              )}
            </Col>
          </Row>
          <Row className='mb18'>
            <Col span={12}>
              <p className='bold'>{$ST.CUSTOMER}</p>
              <p>{`${customerName} ${customerSurname}`}</p>
            </Col>
            <Col span={12}>
              <p className='bold'>{$ST.PHONE_SHORT}</p>
              <p>{phone}</p>
            </Col>
          </Row>
          <Row className='mb18'>
            <Col span={12}>
              <p className='bold'>{$ST.ADDRESS}</p>
              <p>{`${title} ${line
                .split($ST.SEPERATOR)
                .join($ST.CONCATENATOR)} ${city}`}</p>
            </Col>
            <Col span={12}>
              <p className='bold'>{$ST.ORDER_NOTES}</p>
              <p className='bold'>{orderNotes}</p>
            </Col>
          </Row>
          {$S.isPackageOrderDetailPrintable && (
            <Row className='mb18'>
              <PrintableArea
                trigger={
                  <Button className='print-button center'>{$ST.PRINT}</Button>
                }
              >
                <PrintableView {...{ packageOrder }} />
              </PrintableArea>
            </Row>
          )}
          <Row>
            <Select
              size='large'
              defaultValue={selectedActionId}
              className='ant-col-xs-24 mb18'
              onChange={this.handleActionChange}
              placeholder={$ST.SELECT_ACTION}
            >
              <Option key='empty' value='empty'>
                -
              </Option>
              {selectBoxOptions &&
                selectBoxOptions.map((button, index) => {
                  const { id, label } = button;
                  return (
                    <Option
                      key={index}
                      value={id}
                      disabled={isOptionDisabled(button.command)}
                    >
                      {label}
                    </Option>
                  );
                })}
            </Select>
          </Row>
          {packageItemSet &&
            packageItemSet.map((packageItem, index) => {
              const {
                id,
                orderItem: {
                  product: { sku, name, image },
                  price,
                  currency,
                },
              } = packageItem;

              const cardSelectedClass = selectedIds.includes(id)
                ? 'selected'
                : '';

              return (
                <Row key={index}>
                  <Col
                    xs={24}
                    className={`card pointer clickable ${cardSelectedClass}`}
                    onClick={this.handleCheckBoxChange.bind(this, packageItem)}
                  >
                    <Checkbox
                      checked={this.isPackageItemChecked(packageItem)}
                      className='checkbox'
                    />
                    <Col xs={24}>
                      <Row>
                        <Col span={16}>
                          <p>{name}</p>
                          <p className='special-color bold'>{`${price} ${currencyText(
                            currency
                          )}`}</p>
                          <p className='mb0'>{sku}</p>
                        </Col>
                        <Col span={8} align='right'>
                          <Image
                            src={thumbnailImageUrl(image, 60, 60)}
                            width={60}
                            height={60}
                            onClick={(event) => {
                              event.stopPropagation();
                              onOpenImageModal(
                                thumbnailImageUrl(image, 300, 300),
                                300,
                                300
                              );
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Col>
                </Row>
              );
            })}
        </div>
        {selectedIds.length > 0 ? (
          <Button
            classes='special-bg-color white button fixed-button center pointer'
            disabled={!isApplyButtonClickable}
            onClick={() => {
              const { id } = selectBoxOptions.find(
                ({ id }) => id === selectedActionId
              );
              onActionClick(selectedIds, getActionParams(id, actionButtons));
            }}
          >
            {$ST.APPLY}
          </Button>
        ) : (
          actionButton && (
            <Button
              classes='special-bg-color white button fixed-button center pointer'
              disabled={pendingAnyAction}
              onClick={() => {
                const { id } = actionButton;
                onActionClick(undefined, getActionParams(id, actionButtons));
              }}
            >
              {actionButton.label}
            </Button>
          )
        )}
      </div>
    );
  }
}

export default MobileView;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderDetail/mobileView/index.js